<template>
  <div
    :class="[
      'd-flex  align-items-start',
      { 'text-justify': justify },
      { 'single-line': singleLine },
      {
        'w-100 justify-content-between': spaceBetween
      }
    ]"
  >
    <div class="ml-1 flex-shrink-0 d-flex align-items-center">
      <font-awesome-icon
        v-if="icon"
        :class="iconClass"
        :icon="icon"
        class="ml-2"
      />

      <span :class="[masterClass, labelClass]"> {{ label }} : </span>
    </div>

    <span :class="[masterClass, valueClass]">
      <template v-if="computedValue !== undefined">
        {{ computedValue !== null ? computedValue : '-' }}
      </template>

      <slot name="value"></slot>
    </span>

    <span
      v-if="computedValue !== null && unit"
      :class="unitClass"
      class="text-muted mr-1"
    >
      {{ unit }}
    </span>

    <slot name="append"></slot>
  </div>
</template>

<script>
export default {
  name: 'BrbLabelValue',
  props: {
    icon: [String, Array],
    iconClass: [String, Array, Object],
    label: String,
    labelClass: [String, Array, Object],
    value: {
      default: undefined
    },
    valueClass: [String, Array, Object],
    unit: String,
    unitClass: [String, Array, Object],
    masterClass: [String, Array, Object],
    justify: Boolean,
    singleLine: Boolean,
    spaceBetween: Boolean,
    valueOptions: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    computedValue() {
      if (this.valueOptions && this.valueOptions.length) {
        const option = this.valueOptions.find(
          (option) => option.id === this.value
        )
        if (option && (option.title || option.label || option.text))
          return option.title || option.label || option.text
        return this.value
      }
      return this.value
    }
  }
}
</script>
